// extracted by mini-css-extract-plugin
export default {"carouselDots":"CarouselDots_carouselDots__Us9k8"};